import React from 'react';
import ReactDom from 'react-dom';

import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';
import NewsletterBlogsList from '../Components/NewsletterBlogsList/index.jsx';

import newsletterBlogs from '../Services/NewsletterBlogs/index.jsx';


export default function(document) {
  var element = document.getElementById('cs-newsletter-blogs');

  if (element) {
    var newsCategories = element.dataset.newsCategory;
    if (newsCategories) {
      newsCategories = newsCategories.split(',');
    }

    ReactDom.render(
      <ErrorBoundary>
        <NewsletterBlogsList
          newsletterBlogsService={newsletterBlogs}
          newsletterBlogCategories={newsCategories}
        />
      </ErrorBoundary>,
      element
    );
  }
};

